import React from "react";
import { FloorFilterDropdown } from "@/ui/_to_replace/FloorFilterDropdown";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { FloorIcon } from "@cmp-src/icons/icons";

interface ReserveFormFloorSelectorProps {
  className?: string;
}

export const ReserveFormFloorSelector = ({
  className
}: ReserveFormFloorSelectorProps) => {
  const { resource, floors, filterFloor, setFilterFloor } = useReserveForm();
  return (
    <FloorFilterDropdown
      readonly={!!resource}
      floors={floors ?? []}
      floor={filterFloor}
      setFloor={setFilterFloor}
      customIcon={<FloorIcon className="h-4 w-4 opacity-50" />}
      className={className ?? "grow"}
    />
  );
};
